/**
 * Free (reward-link) pages temporarily taken down for the AdSense review,
 * 2026-10-10. Each of these games had ZERO live links in bonus_links when this
 * was written, so its free page was an empty list (thin content).
 *
 * How it works: next.config.ts sends /<game>/<reward> to the game's overview
 * with a TEMPORARY redirect (307), and sitemap.ts leaves the URL out. The page
 * code and its content are untouched.
 *
 * TO BRING ONE BACK (e.g. after AdSense approval, or when links resume):
 * delete its line here and redeploy. Nothing else to change.
 *
 * The other 8 zero-link games are hidden entirely (all pages) via
 * HIDDEN_FOR_NOW_SLUGS in games.ts; the two below stay because their guides
 * are on the Bing list.
 *
 * Deliberately NOT paused (their free pages are on the user's Bing-traffic
 * list): take-5-slots, cash-frenzy-casino.
 */
export const PAUSED_FREE_PAGES: Record<string, string> = {
  "diggys-adventure": "rare-gems",
  "neverland-casino": "free-coins",
};

/** True when this game's free page is paused (it redirects to the overview). */
export const isFreePagePaused = (slug: string, reward: string) =>
  PAUSED_FREE_PAGES[slug] === reward;

/** Link target for a game's free page: the overview while the page is paused,
 *  so no internal link points at a redirect. */
export const freePageHref = (slug: string, reward: string) =>
  isFreePagePaused(slug, reward) ? `/${slug}` : `/${slug}/${reward}`;
